import { z } from 'zod';

/** The request/response header carrying a site's logistics revision — the
 *  version of the site's logistics a Logistics page loaded, sent back on its
 *  writes, and the new version every write answers with. */
export const LOGISTICS_REVISION_HEADER = 'X-Logistics-Revision';

/** A revision: a non-negative integer, bounded so it always round-trips
 *  through a header and a JS number exactly. */
export const LogisticsRevisionSchema = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);

/** `GET /api/sites/:siteId/logistics/revision`'s body — one definition the
 *  backend answers with and the frontend parses. */
export const LogisticsRevisionResponseSchema = z.object({ revision: LogisticsRevisionSchema });

const REVISION_HEADER_PATTERN = /^\d{1,15}$/;

/** A revision header's value, or null when it is absent or malformed —
 *  one parser for the request header the server gates on and the response
 *  header the page adopts. */
export function parseRevisionHeader(raw: string | null | undefined): number | null {
  return typeof raw === 'string' && REVISION_HEADER_PATTERN.test(raw) ? Number(raw) : null;
}
